import { lazy } from 'react';
import { useUiContext } from './components/Contexts/UIContext/uiCtx';
import { useLanguageSynchronizer } from './localization/hooks';
import './localization/init'; // Import the i18n configuration

const Router = lazy(() => import('./Router/Router').then(m => ({ default: m.Router })));
const PhoneApp = lazy(() => import('./PhoneApp').then(m => ({ default: m.PhoneApp })));

export const App = () => {
    const { isInPhoneMode } = useUiContext();
    useLanguageSynchronizer();
    return <>{isInPhoneMode ? <PhoneApp /> : <Router />}</>;
};
